"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    root: {
      fontFamily: 'Vodafone',
      borderRadius: theme.spacing(1),
      '& .MuiSelect-root:focus': {
        borderRadius: theme.spacing(1),
        backgroundColor: 'transparent'
      },
      '& .MuiInputBase-root': {
        borderRadius: theme.spacing(1),
        '& .MuiInputBase-input': _defineProperty({
          borderRadius: theme.spacing(1),
          fontSize: theme.typography.h5.fontSize,
          height: theme.spacing(3)
        }, theme.breakpoints.down('xs'), {
          height: theme.spacing(1.5),
          fontSize: theme.typography.body1.fontSize
        })
      },
      '& .MuiOutlinedInput-notchedOutline': {
        border: "1px solid ".concat(theme.palette.text.secondary)
      },
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderRadius: theme.spacing(1),
        border: "1px solid ".concat(theme.palette.text.secondary)
      },
      '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderRadius: theme.spacing(1),
        border: "1px solid ".concat(theme.palette.text.secondary)
      },
      '& .Mui-disabled .MuiOutlinedInput-notchedOutline': {
        borderRadius: theme.spacing(1),
        border: "1px solid ".concat(theme.palette.text.secondary)
      },
      '& .MuiFormLabel-root': _defineProperty({
        color: theme.palette.text.secondary
      }, theme.breakpoints.down('xs'), {
        fontSize: theme.typography.caption.fontSize
      }),
      '& .MuiFormHelperText-root': {
        color: theme.palette.text.secondary,
        fontSize: theme.typography.caption.fontSize,
        '&.Mui-error': {
          color: theme.palette.primary.main
        },
        '&.Mui-disabled': {
          color: theme.palette.text.disabled
        }
      }
    },
    paper: {
      marginTop: theme.spacing(1),
      '& .MuiList-padding': {
        paddingTop: 0,
        paddingBottom: 0
      }
    },
    menuItemRoot: {
      padding: theme.spacing(1.5)
    }
  };
});
/**
 * ** Select fields are used to select an option among other pre-defined options. **
 *
 */

var Select = function Select(_ref) {
  var label = _ref.label,
      fullWidth = _ref.fullWidth,
      options = _ref.options,
      value = _ref.value,
      _onChange = _ref.onChange,
      helperText = _ref.helperText,
      disabled = _ref.disabled;
  var styles = useStyles();
  return /*#__PURE__*/_react.default.createElement(_core.FormControl, {
    variant: "outlined",
    fullWidth: fullWidth,
    classes: {
      root: styles.root
    }
  }, label && /*#__PURE__*/_react.default.createElement(_core.InputLabel, {
    htmlFor: "outlined-selector"
  }, label), /*#__PURE__*/_react.default.createElement(_core.Select, {
    variant: "outlined",
    label: label || undefined // to handle empty label case ""
    ,
    value: value,
    disabled: disabled,
    onChange: function onChange(event) {
      return _onChange(event.target.value);
    },
    MenuProps: {
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'left'
      },
      marginThreshold: 4,
      getContentAnchorEl: null,
      classes: {
        paper: styles.paper
      }
    },
    inputProps: {
      name: 'outlined-selector'
    }
  }, options.map(function (option, i) {
    return [/*#__PURE__*/_react.default.createElement(_core.MenuItem, {
      value: option.value,
      classes: {
        root: styles.menuItemRoot
      }
    }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
      variant: "body2",
      color: "textSecondary"
    }, option.label)), i < options.length - 1 ? /*#__PURE__*/_react.default.createElement(_core.Divider, {
      variant: "middle"
    }) : null];
  })), helperText && /*#__PURE__*/_react.default.createElement(_core.FormHelperText, null, helperText));
};

Select.propTypes = {
  /** The floating label of the select field */
  label: _propTypes.default.string,

  /** The value of the select field */
  value: _propTypes.default.string,

  /** Full width option of the select field */
  fullWidth: _propTypes.default.bool,

  /** The Disable state of the select field */
  disabled: _propTypes.default.bool,

  /** Select options */
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool])
  })),

  /** Callback that returns the changed value */
  onChange: _propTypes.default.func,

  /** The Helper text value of the select field */
  helperText: _propTypes.default.string
};
Select.defaultProps = {
  value: null,
  fullWidth: false,
  label: null,
  disabled: false,
  options: [],
  helperText: null,
  onChange: null
};
var _default = Select;
exports.default = _default;